import { graphql } from "gql.tada";
import { OrganizationProjectsFragment } from "./fragments";

/**
 * Onboarding resolverだけが失敗した場合に、主要なnavigationを維持するためのfallback。
 * 通常時は下の統合queryだけを使うため、request削減の経路には影響しない。
 */
export const WorkspaceSidebarCoreDataQuery = graphql(
  `
    query WorkspaceSidebarCoreData($organizationId: ID!) {
      node(id: $organizationId) {
        ...OrganizationProjects_organization
        ... on Organization {
          dashboardOrder
          dashboards {
            id
            name
          }
        }
      }
    }
  `,
  [OrganizationProjectsFragment],
);

/**
 * Dashboard resolverだけが失敗した場合に、Project navigationを維持するためのfallback。
 * `dashboards`を同じnode selectionへ含めるとnon-null propagationでOrganization全体が
 * nullになるため、このexceptional pathではProject fragmentだけを取得する。
 */
export const WorkspaceSidebarProjectsDataQuery = graphql(
  `
    query WorkspaceSidebarProjectsData($organizationId: ID!) {
      node(id: $organizationId) {
        ...OrganizationProjects_organization
      }
    }
  `,
  [OrganizationProjectsFragment],
);

/**
 * Project resolverだけが失敗した場合に、Dashboard navigationを維持するためのfallback。
 * Project fragmentを同じnode selectionへ含めるとnon-null propagationでOrganization全体が
 * nullになるため、このexceptional pathではDashboard fieldだけを取得する。
 */
export const WorkspaceSidebarDashboardsDataQuery = graphql(`
  query WorkspaceSidebarDashboardsData($organizationId: ID!) {
    node(id: $organizationId) {
      ... on Organization {
        id
        __typename
        dashboardOrder
        dashboards {
          id
          name
        }
      }
    }
  }
`);

/**
 * Common sidebar data is intentionally fetched as one operation so workspace
 * navigation does not wait for several independent server-side requests.
 */
export const WorkspaceSidebarDataQuery = graphql(
  `
    query WorkspaceSidebarData($organizationId: ID!) {
      node(id: $organizationId) {
        ...OrganizationProjects_organization
        ... on Organization {
          dashboardOrder
          dashboards {
            id
            name
          }
        }
      }
      unfinishedSearchAnalyticsOnboardingSessions(
        organizationID: $organizationId
      ) {
        projectID
        status
        latestSnapshotID
      }
      completedSearchAnalyticsOnboardingSessions(
        organizationID: $organizationId
      ) {
        projectID
        status
        latestSnapshotID
      }
      unfinishedUserAnalyticsOnboardingSessions(
        organizationID: $organizationId
      ) {
        projectID
        status
        latestSnapshotID
      }
      completedUserAnalyticsOnboardingSessions(
        organizationID: $organizationId
      ) {
        projectID
        status
        latestSnapshotID
      }
    }
  `,
  [OrganizationProjectsFragment],
);
